/**
 * Generated by orval. Do not edit manually.
 */

export type FeedbackAccountAgeBandChoice =
  (typeof FeedbackAccountAgeBandChoice)[keyof typeof FeedbackAccountAgeBandChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackAccountAgeBandChoice = {
  under_3_months: 'under_3_months',
  '3_to_12_months': '3_to_12_months',
  over_1_year: 'over_1_year',
  unknown: 'unknown',
} as const
